import { downForMaintenance } from '../../lib/config';
import { Alert } from '../Alert';
import { StyledDialog } from '../StyledDialog/StyledDialog';

export const DownForMaintenanceModalUi = () => {
  return (
    <StyledDialog
      open={true}
      onClose={() => {}}
      title={'Maintenance'}
      panelClassName="max-w-[406px]"
      childrenContainerClassName="flex flex-col gap-5"
      hideCloseButton={true}
      backdropClassName={'bg-black'}
    >
      <Alert variant="warning">
        Ethereal is currently down for maintenance. Please come back later.
      </Alert>
    </StyledDialog>
  );
};

/**
 * Displays a notice to users when the app is down for maintenance. Toggled through a feature flag.
 */
export const DownForMaintenanceModal = () => {
  if (!downForMaintenance) return null;

  return <DownForMaintenanceModalUi />;
};
